import { render, staticRenderFns } from "./pay-success.vue?vue&type=template&id=1c9fabe3&scoped=true&"
import script from "./pay-success.vue?vue&type=script&lang=js&"
export * from "./pay-success.vue?vue&type=script&lang=js&"
import style0 from "./pay-success.vue?vue&type=style&index=0&id=1c9fabe3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9fabe3",
  null
  
)

export default component.exports